var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.394,
    height: 25.394,
    viewBox: "0 0 25.394 25.394",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.e{fill:none;}.b{stroke:#2c3b50;}.c,.d{stroke:none;}.d{fill:#2c3c50;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.313 -7.357)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(7.313 20.051) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M.141.049s9.707-.757,14.144,3.68S17.89,17.8,17.89,17.8,7.839,19.05,3.4,14.613.141.049.141.049Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d fill-hover",
    d: "M 1.779923439025879 1.000001907348633 C 1.512548446655273 1.000001907348633 1.272642135620117 1.003597259521484 1.065769195556641 1.008777618408203 C 0.9104480743408203 3.454623222351074 0.7767581939697266 10.57334518432617 4.109044075012207 13.90562152862549 C 6.767224311828613 16.56382179260254 11.88616371154785 16.96072196960449 14.70091438293457 16.96072196960449 C 15.61505031585693 16.96072196960449 16.39286231994629 16.92048645019531 16.93624496459961 16.88097381591797 C 17.01217269897461 14.52714061737061 16.91518783569336 7.772830009460449 13.57850360870361 4.436161994934082 C 12.27347373962402 3.131132125854492 10.29091453552246 2.176992416381836 7.685873985290527 1.600242614746094 C 5.445103645324707 1.104141235351562 3.237393379211426 1.000001907348633 1.779923439025879 1.000001907348633 M 1.779925346374512 1.9073486328125e-06 C 4.73969841003418 1.9073486328125e-06 10.97722816467285 0.4206581115722656 14.28561401367188 3.72905158996582 C 18.72280311584473 8.166232109069824 17.8900146484375 17.7977409362793 17.8900146484375 17.7977409362793 C 17.8900146484375 17.7977409362793 16.58127212524414 17.96072578430176 14.70090866088867 17.96072578430176 C 11.36843490600586 17.96072578430176 6.238544464111328 17.44934844970703 3.401933670043945 14.61273193359375 C -1.035255432128906 10.17555141448975 0.1412830352783203 0.04902267456054688 0.1412830352783203 0.04902267456054688 C 0.1412830352783203 0.04902267456054688 0.7700748443603516 1.9073486328125e-06 1.779925346374512 1.9073486328125e-06 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b fill-hover",
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4,
    cy: 4,
    r: 3.5
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.70cbfe47.svg";
export { ForwardRef as ReactComponent };